import React from 'react';
import Footer from '../components/Footer';
import Nav from '../components/Nav';
import BottomNav from '../components/BottomNav';
import ChoirGallery from '../components/ChoirGallery';

//The <ChoirGallery galleryId={0} /> component takes an id prop that links to the folder in the images directory. To add a new gallery, create a new folder with the same naming convention and add a new component below with that gallery number as an ID. Then update the GalleryData file in the services directory.

function Gallery() {
	return (
		<div className='flex flex-col'>
			<Nav />
			<div className='bg-info text-base-100'>
				<h1 className='p-10 text-center font-heading text-2xl'>Gallery</h1>
			</div>
			<div className='bg-secondary p-10 text-center'>
				<p>
					Here are some pictures from our several performances and events from
					the year!
				</p>
			</div>
			<div className='flex flex-col items-center gap-10 p-10'>
				{/* <h3 className='font-lora text-3xl font-bold'>Winter Concert</h3> */}
				<div className='w-full max-w-6xl'>
					<ChoirGallery galleryId={0} />
				</div>
			</div>
			{/* <div className='flex flex-col items-center gap-10 bg-accent p-10'>
				<h3 className='font-lora text-3xl font-bold'>Photo Group Title 2</h3>
				<div className='w-full'>
					<ChoirGallery galleryId={1} />
				</div>
			</div>
			<div className='flex flex-col items-center gap-10 p-10'>
				<h3 className='font-lora text-3xl font-bold'>Photo Group Title 3</h3>
				<div className='w-full'>
					<ChoirGallery galleryId={2} />
				</div>
			</div> */}
			<BottomNav />
			<Footer />
		</div>
	);
}
export default Gallery;
